// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding-guide":"Guide_dp3-crowdfunding-guide__xDWCM"};